/**
 * Returns a function, that, when invoked, will only be triggered at most once during
 * a given window of time.
 * @param {Function} fn - Callback function.
 * @param {number} [wait=300] - Time window (in milliseconds).
 * @returns {Function}
 */
function throttle(fn, wait = 300) {
  let throttleTimeoutId = -1;
  let tick = false;

  return () => {
    clearTimeout(throttleTimeoutId);
    throttleTimeoutId = setTimeout(fn, wait);

    if (!tick) {
      fn.call();
      tick = true;
      setTimeout(() => {
        tick = false;
      }, wait);
    }
  };
}

if (!customElements.get('sticky-atc')) {
  customElements.whenDefined('product-form').then(() => {
    class StickyAtc extends customElements.get('product-form') {
      constructor() {
        super();

        this.section = this.closest('.section-main-product');
        this.buyButtons = this.section.querySelector('.quantity-submit-row');
        if (!this.buyButtons) return;

        this.mainProductForm = this.section.querySelector('product-form');
        this.mainProductSubmitForm = this.mainProductForm.getSubmitForm();
        this.submitForm = this.getSubmitForm();
        this.imageContainer = this.querySelector('.sticky-atc__image');
        this.variantTitle = this.querySelector('.sticky-atc__details__variant__title');
        this.variantTitle?.toggleAttribute('hidden', !this.section.querySelector('variant-picker'));
        this.button = this.querySelector('.add-to-cart');

        // INICIO: CONECTA A FAIXA AO PICKER E AO ATC PRINCIPAL
        this.addEventListener('click', (event) => {
          const clickedButton = event.target.closest(
            '.sticky-atc__buttons .add-to-cart'
          );
          if (!clickedButton || !this.contains(clickedButton)) return;

          const picker = this.section.querySelector(
            'image-variant-picker-imagevariantpickerkkewkh'
          );
          const mainButton = this.section.querySelector(
            '[data-dynamic-variant-content="buy-buttons-atc"] button'
          );

          // Mantém o comportamento original em produtos sem nosso Picker
          if (!picker || !mainButton) return;

          event.preventDefault();
          event.stopImmediatePropagation();

          const groups = Array.from(
            picker.querySelectorAll('[data-option-index]')
          );
          const selectionComplete = groups.length > 0 &&
            groups.every((group) =>
              group.querySelector('button[aria-pressed="true"]')
            );

          if (!selectionComplete || mainButton._locked) {
            const wrap = picker.closest('.ivp-picker-wrap');

            if (wrap) {
              // Usa o mesmo enquadramento do botão Choose principal
              picker.dispatchEvent(new Event('ivp:frame-picker'));
            } else {
              // Preserva a navegação no desktop
              theme.scrollToRevealElement(picker);
            }
            return;
          }

          // Reutiliza a ação principal: ATC, UPDATE CART ou CHECKOUT
          if (!mainButton.disabled &&
              mainButton.getAttribute('aria-disabled') !== 'true' &&
              mainButton.textContent.trim().toUpperCase() !== 'UPDATING...') {
            mainButton.click();
          }
        }, true);
        // FIM: CONECTA A FAIXA AO PICKER E AO ATC PRINCIPAL

        // INICIO: SINCRONIZA O TEXTO DA FAIXA
        const customPicker = this.section.querySelector(
          'image-variant-picker-imagevariantpickerkkewkh'
        );
        const mainAtcArea = this.section.querySelector(
          '[data-dynamic-variant-content="buy-buttons-atc"]'
        );

        if (customPicker && mainAtcArea) {
          this.pickerStateObserver = new MutationObserver(() => {
            this.syncPickerState();
          });

          this.pickerStateObserver.observe(customPicker, {
            subtree: true,
            attributes: true,
            attributeFilter: ['aria-pressed']
          });

          this.pickerStateObserver.observe(mainAtcArea, {
            subtree: true,
            childList: true,
            characterData: true,
            attributes: true,
            attributeFilter: ['disabled', 'aria-disabled', 'class']
          });
        }
        // FIM: SINCRONIZA O TEXTO DA FAIXA


        this.throttledOnScroll = throttle(this.handleScroll.bind(this));
        window.addEventListener('scroll', this.throttledOnScroll);

        this.section.addEventListener('on:media-gallery:change', this.updateImage.bind(this));

        this.updateImage();
        this.updateAddToCartButton();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.throttledOnScroll);
        this.pickerStateObserver?.disconnect();
      }

      /**
       * Handles submission of the product form.
       * @param {object} evt - Event object.
       */
      async handleSubmit(evt) {
        evt.preventDefault();

        const variantId = this.section.querySelector('.js-product-form input[name="id"]').value;
        if (!variantId) {
          const target = this.section.querySelector('#product-info');
          if (target && target.offsetParent) {
            evt.preventDefault();
            theme.scrollToRevealElement(target);
          }
          return;
        }

        // Validate main form
        const customFormValid = this.mainProductForm.validate();
        if (!customFormValid || !this.mainProductSubmitForm.reportValidity()) {
          evt.preventDefault();
          if (!customFormValid) {
            theme.scrollToRevealElement(this.mainProductForm);
          } else {
            const input = Array.from(this.mainProductSubmitForm.elements).find(
              (el) => !el.checkValidity()
            );
            setTimeout(() => theme.scrollToRevealElement(input), 100);
          }
          return;
        }

        // Clear copied data
        this.submitForm.querySelectorAll('[data-copied]').forEach((el) => el.remove());

        // Copy data
        const formData = new FormData(this.mainProductSubmitForm);
        for (const p of formData) {
          if (!this.submitForm.querySelector(`[name="${p[0]}"]`)) {
            const input = document.createElement('input');
            input.name = p[0];
            input.value = p[1];
            input.hidden = true;
            input.setAttribute('data-copied', '');
            this.submitForm.append(input);
          }
        }
        super.handleSubmit(evt);
      }

      /**
       * Determine visibility after scroll.
       */
      handleScroll() {
        const topOffset = document.querySelector('.pageheader--sticky') ? document.querySelector('.section-header').offsetHeight : 0;
        this.classList.toggle(
          'sticky-atc--out',
          this.buyButtons.getBoundingClientRect().bottom > topOffset
        );

        document.body.classList.toggle(
          'scrolled-to-bottom',
          window.scrollY + window.innerHeight + 100 > document.body.scrollHeight
        );
      }

      /**
       * Updates the image.
       */
      updateImage() {
        const mainImage = this.section.querySelector('.media-gallery .main-image .slider__item.is-active .product-media img');

        if (mainImage) {
          this.imageContainer.innerHTML = mainImage.outerHTML;
        } else {
          this.imageContainer.textContent = '';
        }
      }

      /**
       * Updates the add to cart button text.
       */
      updateAddToCartButton() {
        if (this.syncPickerState()) return;

        // Mantém o comportamento original em produtos sem nosso Picker
        const variantId = this.section.querySelector(
          '.js-product-form input[name="id"]'
        ).value;

        if (!variantId) {
          this.button.innerHTML = this.button.dataset.unavailableText;
        }
      }

      syncPickerState() {
        const picker = this.section.querySelector(
          'image-variant-picker-imagevariantpickerkkewkh'
        );
        const mainButton = this.section.querySelector(
          '[data-dynamic-variant-content="buy-buttons-atc"] button'
        );
        const stickyButton = this.querySelector(
          '.sticky-atc__buttons .add-to-cart'
        );

        if (!picker || !mainButton || !stickyButton) return false;

        const groups = Array.from(
          picker.querySelectorAll('[data-option-index]')
        );
        const selected = groups.map((group) =>
          group.querySelector('button[aria-pressed="true"]')
        );
        const complete = groups.length > 0 &&
          selected.every(Boolean);
        const ready = complete && !mainButton._locked;
        const mainText = mainButton.textContent.trim().toUpperCase();

        let label = 'Choose Insert';

        if (ready) {
          if (mainText === 'CHECKOUT') {
            label = 'Checkout';
          } else if (mainText === 'UPDATE CART') {
            label = 'Update Cart';
          } else if (mainText === 'UPDATING...') {
            label = 'Updating...';
          } else {
            label = 'Add to Cart';
          }
        }

        if (stickyButton.textContent !== label) {
          stickyButton.textContent = label;
        }

        // Sem seleção completa, mantém o título do produto
        const title = this.querySelector('.sticky-atc__details__title');
        let description = ready
          ? selected.map((button) => button.dataset.optionValue).join(' · ')
          : title?.dataset.originalProductTitle;

        if (ready) {
          const input = this.section.querySelector(
            '[data-dynamic-variant-content="buy-buttons-input-id"]'
          );
          const variant = picker._variantData?.find(
            (item) => String(item.id) === String(input?.value)
          );

          if (variant && Number.isFinite(Number(variant.price))) {
            const price = (Number(variant.price) / 100).toLocaleString(
              'en-US', { style: 'currency', currency: 'USD' }
            );
            description += ' · ' + price;
          }
        }

        if (title) {
          if (!title.dataset.originalProductTitle) {
            title.dataset.originalProductTitle = title.textContent.trim();
          }

          const text = ready
            ? description
            : title.dataset.originalProductTitle;

          if (title.textContent !== text) {
            title.textContent = text;
          }
        }

        // Evita repetir a variante abaixo da descrição
        const variantRow = this.querySelector(
          '.sticky-atc__details__variant'
        );
        if (variantRow) variantRow.hidden = true;

        if (stickyButton.tagName === 'BUTTON') {
          stickyButton.disabled = ready && (
            mainButton.disabled ||
            mainButton.getAttribute('aria-disabled') === 'true' ||
            mainText === 'UPDATING...'
          );
        }

        return true;
      }
    }

    customElements.define('sticky-atc', StickyAtc);
  });
}
